const SHORT_UPPERCASE_ACRONYM_PATTERN = /^[A-Z]{2,4}$/
const UPPERCASE_ACRONYM_PATTERN = /[A-Z]{2,4}/g

const isShortUppercaseAcronym = (value: string): boolean => SHORT_UPPERCASE_ACRONYM_PATTERN.test(value)

const extractUppercaseAcronyms = (value: string): string[] => (
  [...new Set(value.match(UPPERCASE_ACRONYM_PATTERN) ?? [])]
)

const restoreUppercaseAcronyms = (text: string, acronyms: string[]): string => acronyms.reduce((result, acronym) => {
  const lower = acronym.toLowerCase()

  return result.replace(
    new RegExp(`(^|[^a-z])${lower}(?![a-z])`, 'gi'),
    (_, prefix: string) => `${prefix}${acronym}`,
  )
}, text)

const extractHyphenatedTitleCaseSegments = (value: string): string[] => (
  value.match(/(?<=-)[A-Z][a-z]+/g) ?? []
)

const restoreHyphenatedTitleCaseSegments = (text: string, segments: string[]): string => (
  segments.reduce((result, segment) => {
    const lower = segment.toLowerCase()

    return result.replace(new RegExp(`-${lower}(?![a-z])`, 'i'), `-${segment}`)
  }, text)
)

/** Convert title-case text to sentence case while preserving short acronyms (e.g. AI, KI, IA). */
export function toSentenceCase(value: string): string
export function toSentenceCase(value: null): null
export function toSentenceCase(value: undefined): undefined
export function toSentenceCase(value: string | null | undefined): string | null | undefined
export function toSentenceCase(value: string | null | undefined): string | null | undefined {
  if (typeof value !== 'string' || value.length === 0) {
    return value
  }

  if (isShortUppercaseAcronym(value)) {
    return value
  }

  const acronyms = extractUppercaseAcronyms(value)
  const hyphenatedSegments = extractHyphenatedTitleCaseSegments(value)
  const sentenceCased = value.toLowerCase().replace(/^./, (char) => char.toUpperCase())

  return restoreHyphenatedTitleCaseSegments(
    restoreUppercaseAcronyms(sentenceCased, acronyms),
    hyphenatedSegments,
  )
}
